import React from 'react';
import { getFileArchiveData } from 'utils/apiRequests';

import { FileArchiveContext } from '.';

export class FileArchiveContextProvider extends React.Component {
	state = {
		fileArchive: null,
	};

	componentDidMount() {
		this.fetchData();
	}

	fetchData = () => {
		getFileArchiveData()
			.then(fileArchive => {
				this.setState({ fileArchive });
			})
			.catch(() => {
				this.setState({ fileArchive: [] });
			});
	};

	render() {
		return (
			<FileArchiveContext.Provider
				value={{
					...this.state,
					refetch: this.fetchData,
				}}
			>
				{this.state.fileArchive ? this.props.children : null}
			</FileArchiveContext.Provider>
		);
	}
}
